import { Box, LinearProgress, Typography } from '@mui/material';
import {
  formatTileLoadLabel,
  getTileLoadPercent,
} from '../utils/tileLoadProgress';
import type { TileLoadSnapshot } from '../utils/tileLoadProgress';

type Props = {
  progress: TileLoadSnapshot;
};

export default function MetricsFrameworkLoadProgress({ progress }: Props) {
  if (!progress.visible) return null;

  const label = formatTileLoadLabel(progress);
  const value = getTileLoadPercent(progress);

  return (
    <Box sx={{ pt: 1.5, pb: 0.5 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', mb: 0.75 }}
      >
        {label}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={value}
        aria-label={label}
        sx={{ height: 6, borderRadius: 999 }}
      />
    </Box>
  );
}
